import { render, staticRenderFns } from "./CardCustomerInfo.vue?vue&type=template&id=5452b03c&"
import script from "./CardCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./CardCustomerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports